import React, { Component } from 'react';
import Form from '../../components/react-validation/components/form';
import Submit from '../../components/react-validation/components/submit';
import Input from '../../components/react-validation/components/input';
import {Modal} from 'react-bootstrap';
import * as Vali from '../../helper/validator-helper';
import PropTypes from 'prop-types';
// import { DatePicker } from '../../components/datepicker/datepicker';
import Datetime from 'react-datetime';
import { formatTimezoneDateTime } from 'helper/unit-helper';
import * as PhaseActionType from '../constants';
import Moment from 'moment';
import Translate from 'components/translate';

export class EditPhase extends Component {
  static propTypes = {
    errorMsg: PropTypes.array,
    onSubmit: PropTypes.func,
    onCloseModal: PropTypes.func,
    isOpenFormEdit: PropTypes.bool,
    item: PropTypes.object
  }
  constructor(props) {
    super(props);
    this.state = {
      startDate: props.item.startDate,
      dateError: null
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      startDate: nextProps.item.startDate ? nextProps.item.startDate : null
    });

    if (nextProps.errorMsg.length > 0) {
      if (this.form) {
        this.form.showError(this.refs['name'], nextProps.errorMsg[0].error || nextProps.errorMsg[0]);
      }
    }

  }

  onSubmit(e) {

    e.preventDefault();

    var param = this.form.getValues();

    const { startDate } = this.state;

    if (startDate) {
      param['startDate'] = formatTimezoneDateTime(Moment.isMoment(startDate) ? startDate : Moment(startDate));
    }

    this.props.onSubmit(e, param,
      PhaseActionType.UPDATE_PHASE_ASYNC, true);
  }

  onCloseModal = () => {
    this.setState({startDate: null}, () => {
      this.props.onCloseModal();
    });
  }

  render() {
    let {name} = this.props.item;
    if (this.form) {

      name = this.form.getValues().name;

    }
    return <Modal show={this.props.isOpenFormEdit}>
      <div className='modal-header'>
        <h4 className='modal-title'>Edit <Translate translateKey='phase' capitalize /></h4>
      </div>
      <Form ref={c => { this.form = c; }} onSubmit={this.onSubmit.bind(this)}>
        <div className='modal-body'>
          <Input type='hidden' name='id' ref='id' value={this.props.item.id} />
          <Input type='hidden' name='projectId' ref='projectId' value={this.props.item.projectId} />
          <div className='form-group'>
            <label><Translate translateKey='phase' capitalize /> name <strong className='text-danger'>*</strong></label>
            <Input type='text'
              autoFocus
              name='name'
              ref='name'
              value={name || ''}
              placeholder='Phase name'
              className='form-control'
              max='200'
              maxLength='200'
              validations={[Vali.required, Vali.maxlength]} />
          </div >
          <div className='form-group'>
            <label>Start date</label>
            <Datetime
              ref={ref => { this.startdate = ref; }}
              defaultValue={Moment(this.state.startDate)}
              onChange={(selectedDate) => {
                if (Moment(selectedDate, 'MM/DD/YYYY', true).isValid() || selectedDate === '') {
                  this.setState({startDate: selectedDate, dateError: null});
                } else {
                  this.setState({dateError: 'Invalid datetime.'});
                }
              }}
              timeFormat={false}
              dateFormat='MM/DD/YYYY'
              inputProps={{placeholder: 'mm/dd/yyyy'}} 
              closeOnSelect={true}/>
            {this.state.dateError && <span className='text-danger' style={{fontSize: 12, marginTop: 5}}>{this.state.dateError}</span>}
          </div>
        </div>
        <div className='modal-footer'>
          <button type='button' className='btn btn-siteone-default cancel-btn' onClick={this.onCloseModal}>Cancel</button>
          <Submit className='btn btn-primary btn-siteone' disabled={this.state.dateError}>Done</Submit>
        </div>
      </Form>
    </Modal>;
  }
}



// WEBPACK FOOTER //
// ./src/Projects/Components/phase-edit.js